import { getSSCdnImgUrl } from '@/helpers/cdn';
import { Locale } from '@/helpers/languages';
import type { IConfig } from '../CrownMarch25/helpers';

export const config: IConfig = {
  default: {
    translation: 'halloween2026LP',
    defaultBonusCode: 'HWUP',
    fsCount: 35,
    validate: '10.11.2026',
  },
};

export const IMAGE_SRC_PATH = '/lp/halloween2026';

export const img = (src: string) => `${IMAGE_SRC_PATH}/${src}`;

export const DESKTOP_GAMES_COUNT = 8;
export const MOBILE_GAMES_COUNT = 6;

const DE_GAMES = [
  'gamebeat/HellCash',
  'pragmaticexternal/GatesofOlympusSuperScatter',
  'evoplay/TempleofThunderBonusBuy',
  '1spin4win/BoomingFruits81x',
  'pragmaticexternal/BookofFallen',
  'evoplay/HotVolcanoBonusBuy',
  'belatra/WildFruitJam',
  'bgmng/WildCashX9990',
];

const CA_GAMES = [
  'gamebeat/HellCash',
  'gamebeat/BuffaloTrail',
  'pragmaticexternal/WolfGold',
  'pragmaticexternal/GatesofOlympusSuperScatter',
  'zillion/eaglesGold',
  'bgmng/GoldRushWithJohnny',
  'gamebeat/RagingLion',
  'gamebeat/BuffaloDaleGrandWays',
];

const GAMES_BY_LOCALE: Partial<Record<string, string[]>> = {
  [Locale.ENGLISH_AUSTRALIA]: [
    'pragmaticexternal/WolfGold',
    'evoplay/TempleofThunderBonusBuy',
    'gamebeat/BuffaloTrail',
    'gamzix/3x3RoyalPiggyHoldTheSpin',
    'evoplay/HotVolcanoBonusBuy',
    'zillion/eaglesGold',
    'bgmng/WildCashX9990',
    'bgmng/FruitMillionRespin',
  ],
  [Locale.GERMAN]: DE_GAMES,
  [Locale.FRENCH_SWITZERLAND]: DE_GAMES,
  [Locale.ENGLISH_CANADA]: CA_GAMES,
  [Locale.FRENCH_CANADA]: CA_GAMES,
};

const DEFAULT_GAMES = [
  'pragmaticexternal/SugarRush1000',
  'pragmaticexternal/SweetBonanza2500',
  'pragmaticexternal/GatesofOlympusSuperScatter',
  'pragmaticexternal/BookofFallen',
  'playngo/LegacyofDead',
  'playngo/BookofDead',
  'pragmaticexternal/BigBassSplash',
  'nolimit/DuckHuntersDX2',
];

export const getGameImages = (locale: string) =>
  (GAMES_BY_LOCALE[locale] ?? DEFAULT_GAMES).map(getSSCdnImgUrl);

export interface IVipTier {
  key: 'gold' | 'platinum' | 'diamond';
  color: string;
  cashback: string;
}

export const VIP_TIERS: IVipTier[] = [
  { key: 'gold', color: '#F0C018', cashback: '5%' },
  { key: 'platinum', color: '#D3D3D9', cashback: '7%' },
  { key: 'diamond', color: '#854DEB', cashback: '10%' },
];

interface ISize {
  width: number;
  height: number;
}

export interface IPaymentLogo {
  name: string;
  desktop: ISize;
  mobile: ISize;
}

const crypto = (name: string): IPaymentLogo => ({
  name,
  desktop: { width: 38, height: 38 },
  mobile: { width: 30, height: 30 },
});

export const FIAT_PAYMENT_LOGOS: IPaymentLogo[] = [
  {
    name: 'visa',
    desktop: { width: 79, height: 32 },
    mobile: { width: 55, height: 19 },
  },
  {
    name: 'mastercard',
    desktop: { width: 54, height: 32 },
    mobile: { width: 30, height: 19 },
  },
  {
    name: 'apple-pay',
    desktop: { width: 80, height: 32 },
    mobile: { width: 58, height: 23 },
  },
  {
    name: 'bank-transfer',
    desktop: { width: 105, height: 32 },
    mobile: { width: 72, height: 23 },
  },
  {
    name: 'mifinity',
    desktop: { width: 104, height: 20 },
    mobile: { width: 75, height: 15 },
  },
];

export const CRYPTO_PAYMENT_LOGOS: IPaymentLogo[] = [
  'bitcoin',
  'litecoin',
  'ethereum',
  'usdt',
  'solana',
  'trx',
  'dogecoin',
].map(crypto);
